const initialState = {
  gameList: [],
  errorMessage: '',
  actionProcessing: false,
  actionProcessingByProvider: {},
  gameUrl: '',
  extraData: {},
  favorite: [],
  onScroll: () => {},
  containerRef: {
    current: {},
  },
};

export default initialState;
